import { makeSvgImage } from '../../../../../../components/SvgImage/index.ts';

export const House = makeSvgImage(
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 350 190">
    <path
      fill="#354661"
      fillOpacity=".1"
      d="M248.1 146.1s-27.2 0-43 2.9c-23.5 4.4-49.2 16.2-44.5 18.1 5.7 2.4 9.8 3.8 13 6.4 7.3 6 25.2 5.4 39.7 7.2 22.3 2.8 31.2 2.2 54.4 2.2 35 0 64.5.9 89.8-2 25.3-3 42-5.8 54-6.7 12-1 35.3-1.8 36-3.7.7-2 1.2-1.5 2-4.9.6-2.7-8.9-5.2-27.5-10a305.2 305.2 0 0 0-38.3-7.8c-25-3.6-40.7-6.1-66.4-4-7.6.6.7 2.3-19 2.3h-50.2Z"
    />
    <path
      fill="#969CA5"
      d="M131.2 104c14-7.7 26.5-14.2 46.1-12 29.7 3.1 53.2-1.1 89.8 0 7.6.2 9.6 4.4 17.1 4.9 27.3 1.9 57.6-1.4 93.7 1.9 16.8 1.5 28.2-.6 42.5 5.2 9 3.6 15.7 5.2 21.8 10.4 7.1 6.1 17.7 13.4 7.6 18.2-5.4 2.5-12.1-.2-18 2.1-5 2-4.5 5-9 7.4-13.1 7-31.8-1.6-46.6 4.5-3.6 1.5-6.9 5.2-16.4 5.2-9.6 0-62.3-1-107.4-1 0 0-48-1.3-78.3-4.2-24.7-2.4-39.7-9.5-62.5-8.3-11.3.6-2.5-9.7 0-15.8 3.4-8.1 8.8-12.6 19.6-18.5Z"
    />
    <path
      fill="#6E727D"
      d="m362.8 139.5-1.7 12.2h-9.6l1.2-12.2v-9l-4-8.1 2.8-3.9 5.6-1.7v5.6l4 5.2-4 6.7 5.7 5.2Zm-76.8 5.2v6.3h3.5l-1.8-9.9-1.7-3.2-1-7.3-.6-6.6-.4 6.6.4 5.7.6 3.3 1 5.1Zm-48.7 2 .2 3.6-3-.1-2.4-.1 2.2-5 3-1.4 1.5-3.3 1-2.9.6 3-.6 2.5-1 1.5-1.5 2.2Zm-87.6-8.5.4 4.5-4.4-1-3.4-.6 4.4-4.6 3-1.3 1.6-3.3 5.7-4.6-1 1.4-3.2 3.2-.5 2.6-1 1.5-1.6 2.2Z"
    />
    <path
      fill="#ACB4BE"
      d="M131.2 104c14.1-7.7 26.6-14.2 46.1-12 29.7 3.1 53.3-1.1 89.8 0 7.6.2 9.6 4.4 17.2 4.9 27.2 1.9 57.5-1.4 93.6 1.9 16.8 1.5 28.2-.6 42.5 5.2 4.3 1.7 6.1 2.5 7.6 3.4.5.4-.3.7-1.3 1.6-.7.8-2 1.1-2.4 1.4-4.5 2.4-10 3-10 3s-15.5 1.7-30.2 7.8c-3.6 1.5-30.2 9-39.8 9-9.5 0-40.7 1.8-85.8 1.8 0 0-35.5 1-65.7-1.8-24.8-2.4-21.1-4.7-44-3.5-11.2.6-36.8-6-32-11.6 3.6-4.3 3.6-5.2 14.4-11.1Z"
    />
    <path
      fill="#BDC4CE"
      d="M284.3 96.9c-7.6 0-9.6-4.7-17.2-5-36.5-1-60 3.2-89.8 0-19.5-2-32 4.4-46 12-10.9 6-10.2 5.8-9.6 7.1 2 4.2 16 5.6 27.2 5 22.8-1.2 19.1 1 43.9 3.5 30.2 2.9 65.7 1.8 65.7 1.8 45.1 0 76.3-1.8 85.8-1.8 9.6 0 36.2-7.5 39.8-9 14.7-6 32.4-8 32.4-8s-8-2-13.3-2.7c-8.5-1.2-8.3.5-25.2-1-17-1.6-58.6-2-93.7-2Z"
    />
    <path
      fill="#6E727D"
      d="m265 99 7.8-6 4.9 2.3c.6.3-6 4-6 4l-6.8 2-3.8-.2-5.4 1.8-10 1 2.5-.6 6.4-1 3.8-1.7 2.6-.6 4-1Z"
    />
    <path
      fill="#EBD4A8"
      d="M98 128s-27.2-.1-42.9 2.7c-23.5 4.2-45.3 9.5-40.6 11.3 5.7 2.2 5.8 9.5 9 12 7.4 5.7 25.2 5.1 39.7 6.8 22.3 2.7 31.2 2 54.3 2 35 0 64.4 1 89.7-1.9 25.2-2.8 41.8-5.4 53.8-6.3 12-.8 35.3-1.7 36-3.5.7-1.8 1.2-1.4 2-4.6.6-2.6-8.8-5-27.4-9.5a318.3 318.3 0 0 0-38.2-7.4c-25-3.5-40.7-5.9-66.4-3.9-7.5.6.8 2.3-18.8 2.3H98Z"
    />
    <path
      fill="#969CA5"
      d="M88.1 111s-27.2-.2-43 3.3C21.7 119.6-4 133.6.7 135.8c5.7 2.8 9.8 4.6 13 7.7 7.3 7.1 25.2 6.3 39.7 8.5 22.3 3.3 31.2 2.5 54.4 2.5 35 0 64.5 1.1 89.8-2.4 25.3-3.5 42-6.8 54-7.9 12-1 35.3-2.1 36-4.4.7-2.3 1.2-1.7 2-5.7.6-3.2-8.9-6.2-27.5-12a263.7 263.7 0 0 0-38.3-9.1c-25-4.4-40.7-7.4-66.4-4.9-7.6.8.7 2.9-19 2.9H88.2Z"
    />
    <path
      fill="#6E727D"
      d="M222 142.4v5.9l10-1.6v-4.3l-15.1-6.6-2-3.8-8.3-2.4-10.6-3.1 2.5 3 14 4.3v3.9l9.5 4.7Zm-37.3 4.8v6.3l5.2-.4 5.4-.7-4.4-8.7-6.2-3.2-3.4-7.3-2.2-6.6-1.2 6.6 1.2 5.7 2.2 3.3 3.4 5Zm19.3.8v3.2l2.6-.4 2.4-.4-2-4.1-3-1.3-1.5-3.3-1-3-.6 3 .6 2.6 1 1.5 1.5 2.2Zm-96.2 3.7v2.8h-5.2l2.2-4.5 3-1.3 1.6-3.2 1-3 .5 3-.5 2.5-1 1.5-1.6 2.2Zm-91.5-12.5-1.3 5.5-1.7-1.5a24 24 0 0 0-2-1.6l2-4.1 3-1.3 1.6-3.3 5.7-4.6-1 1.4-3.2 3.2-.5 2.6-1 1.5-1.6 2.2Zm249.7-1.8 1.1 5.6s2 0 3-.2l3-.3-4-6.9-3-1.3-1.3-2.6-2-.7-2.2-1.5 2.6 2.8.3 1.3 1 1.5 1.6 2.3Z"
    />
    <path
      fill="#ACB4BE"
      d="M88.1 111s-27.2-.2-42.9 3.3c-23.6 5.3-20.1 12.7-13 15 6.6 2 29.1 5.8 35.3 7 5.6 1 15.7.4 30.7 1.3 11.2.6 21 1.3 29.1 1.3 30 0 21.6-4.3 46.9-7.7 25.3-3.5 15.2-6.9 27.2-8 12-1 19.9 1.4 29.2 1.4s28.7 7.2 29.4 3.2c.6-3.2 30 2.6 11.3-3.2a385 385 0 0 0-47.6-11.6c-25-4.4-40.7-7.4-66.4-4.9-7.6.8.7 2.9-19 2.9H88.2Z"
    />
    <path
      fill="#BDC4CE"
      d="M88.2 111s-27.2-.2-43 3.3c-23.5 5.3-15.1 5.6-8 7.9 6.7 2 24.2 6 30.4 7 5.6 1.2 5.7 1.3 20.6 2.2 11.3.7 19.9 0 28 0 29.9 0 23-4.1 48.3-7.6 25.3-3.5 9.3-7 21.3-8.1 12-1.1 37.3 7.8 38 5.6.8-2.3 29.2 7.3 30 3.3.5-3.2 22.3 1.9 3.6-3.9-14.2-4.4-18-5-33.6-7.7-25-4.4-40.7-7.4-66.4-4.9-7.6.8.7 2.9-19 2.9H88.3Z"
    />
    <path
      fill="#969CA5"
      d="M215.1 131.1s-27.2-.1-43 3.4c-23.5 5.2-49.2 19.2-44.5 21.5 5.7 2.8 9.8 4.5 13 7.6 7.3 7.2 25.2 6.4 39.7 8.5 22.3 3.4 31.2 2.6 54.4 2.6 35 0 64.5 1 89.8-2.4 25.3-3.5 42-6.8 54-8 12-1 35.3-2 36-4.3.7-2.3 1.2-1.8 2-5.8.6-3.2-8.9-6.1-27.5-11.9a263.6 263.6 0 0 0-38.3-9.2c-25-4.3-40.7-7.3-66.4-4.8-7.6.7.7 2.8-19 2.8h-50.2Z"
    />
    <path
      fill="#6E727D"
      d="M349 162.5v6l10-1.7v-4.3l-15-6.5-2-3.9-8.3-2.4-10.6-3 2.5 3 14 4.3v3.9l9.5 4.6Zm-37.3 4.9v6.2l5.2-.4c2-.1 5.4-.6 5.4-.6l-4.4-8.7-6.2-3.2-3.4-7.4-2.2-6.5-1.2 6.5 1.2 5.8 2.2 3.3 3.4 5Zm19.3.8v3.1l2.6-.3 2.4-.4-2-4.1-3-1.3-1.5-3.3-1-3-.6 3 .6 2.5 1 1.5 1.5 2.3Zm-96.2 3.7v2.8h-5.2l2.2-4.5 3-1.3 1.6-3.3 1-3 .5 3-.5 2.6-1 1.5-1.6 2.2Zm-91.5-12.6-1.3 5.5-1.7-1.5-2-1.6 2-4 3-1.4 1.6-3.2 5.7-4.6-1 1.3-3.2 3.3-.5 2.5-1 1.5-1.6 2.2Z"
    />
    <path
      fill="#ACB4BE"
      d="M215.1 131.1s-27.2-.1-42.9 3.4c-23.6 5.2-20.1 12.7-13 15 6.6 2 29.1 5.7 35.3 6.9 5.6 1 15.7.4 30.7 1.3 11.2.7 21 1.4 29.1 1.4 30 0 21.6-4.3 46.9-7.8 25.3-3.5 15.2-6.8 27.2-7.9 12-1 19.9 1.4 29.2 1.4s28.7 7.2 29.4 3.2c.6-3.2 30 2.5 11.3-3.2-14.2-4.4-32-9-47.6-11.7-25-4.3-40.7-7.3-66.4-4.8-7.6.7.7 2.8-19 2.8h-50.2Z"
    />
    <path
      fill="#BDC4CE"
      d="M215.2 131.1s-27.2-.1-43 3.4c-23.5 5.2-15.1 5.6-8 7.8 6.7 2.2 24.2 6 30.4 7.1 5.6 1.1 5.7 1.3 20.6 2.2 11.3.7 19.9 0 28 0 29.9 0 23-4.1 48.3-7.6 25.3-3.5 9.3-7.1 21.3-8.2 12-1 37.3 7.9 38 5.6.8-2.2 29.2 7.3 30 3.4.6-3.2 22.3 1.8 3.6-4-14.2-4.3-18-5-33.6-7.7-25-4.3-40.7-7.3-66.4-4.8-7.6.7.7 2.8-19 2.8h-50.2Z"
    />
    <path
      fill="#969CA5"
      d="M326 66.6c5-2.7 9.3-5 16.1-4.2 10.4 1 18.7-.4 31.5 0 2.7 0 3.4 1.5 6 1.7 9.6.7 20.2-.5 32.9.7 5.8.5 9.8-.2 14.8 1.8 3.2 1.3 5.6 1.8 7.7 3.6 2.5 2.2 6.2 4.7 2.6 6.4-1.9.9-4.2 0-6.2.8-1.8.7-1.6 1.7-3.2 2.5-4.6 2.5-11.2-.5-16.3 1.6-1.3.5-2.5 1.9-5.8 1.9-3.4 0-21.8-.4-37.7-.4 0 0-16.8-.4-27.4-1.5-8.6-.8-13.9-3.3-21.9-2.9-4 .2-.9-3.4 0-5.5 1.2-2.9 3-4.4 6.9-6.5Z"
    />
    <path
      fill="#6E727D"
      d="m332.5 78.6.1 1.6-1.5-.4-1.2-.2 1.5-1.6 1-.5.6-1.1 2-1.6-.3.4-1.1 1.2-.2.9-.4.5-.5.8Z"
    />
    <path
      fill="#ACB4BE"
      d="M326 66.6c5-2.7 9.3-5 16.2-4.2 10.4 1 18.6-.4 31.4 0 2.7 0 3.4 1.5 6 1.7 9.6.7 20.2-.5 32.9.7 5.8.5 9.8-.2 14.8 1.8l2.7 1.2c.2.1 0 .2-.4.6l-.9.4a11 11 0 0 1-3.5 1.1s-5.4.6-10.6 2.7a70 70 0 0 1-14 3.2c-3.3 0-14.2.6-30 .6 0 0-12.4.4-23-.6-8.7-.9-7.4-1.7-15.4-1.3-4 .3-13-2-11.3-4 1.3-1.5 1.3-1.8 5.1-4Z"
    />
    <path
      fill="#BDC4CE"
      d="M379.6 64.1c-2.6 0-3.3-1.7-6-1.7-12.8-.4-21 1-31.4 0-6.9-.8-11.3 1.5-16.2 4.2-3.8 2-3.6 2-3.3 2.5.6 1.4 5.5 2 9.5 1.7 8-.4 6.7.4 15.4 1.2 10.6 1 23 .7 23 .7 15.8 0 26.7-.7 30-.7a70 70 0 0 0 14-3.1C419.8 66.8 426 66 426 66s-2.8-.7-4.7-1c-3-.4-3 .2-8.8-.3-6-.6-20.6-.7-32.9-.7Z"
    />
    <path
      fill="#969CA5"
      d="M310.9 69s-9.6 0-15 1.2c-8.3 1.8-17.3 6.8-15.7 7.6 2 1 3.4 1.5 4.5 2.6 2.6 2.5 8.9 2.3 14 3 7.8 1.2 11 .9 19 .9 12.3 0 22.7.4 31.5-.8 8.9-1.3 14.7-2.4 19-2.8 4.1-.4 12.3-.8 12.6-1.5.2-.8.4-.7.6-2 .3-1.2-3-2.2-9.6-4.2-5-1.6-8-2.3-13.4-3.3-8.7-1.5-14.3-2.5-23.3-1.7-2.6.3.3 1-6.6 1h-17.6Z"
    />
    <path
      fill="#6E727D"
      d="M357.8 80v2.1l3.5-.6V80l-5.3-2.2-.7-1.4-3-.9-3.6-1 .9 1 4.9 1.5v1.4l3.3 1.6Zm-13.1 1.7V84l1.8-.1 2-.2-1.6-3-2.2-1.2-1.2-2.6-.7-2.3-.5 2.3.5 2 .7 1.2 1.2 1.7Zm-26.9 1.6v1h-1.9l.8-1.6 1-.4.6-1.2.4-1 .2 1-.2 1-.4.4-.5.8ZM285.7 79l-.4 1.8-.6-.5-.7-.5.7-1.5 1-.4.6-1.2 2-1.6-.4.5-1 1.1-.3 1-.3.4-.6.8Z"
    />
    <path
      fill="#ACB4BE"
      d="M310.9 69s-9.6 0-15 1.2c-8.3 1.8-7.1 4.5-4.6 5.3 2.3.7 10.2 2 12.4 2.4 2 .4 5.5.2 10.7.5 4 .2 7.4.4 10.2.4 10.5 0 7.6-1.5 16.4-2.7 9-1.2 5.4-2.4 9.6-2.8 4.2-.3 7 .5 10.2.5 3.3 0 10 2.5 10.3 1.1.2-1 10.5 1 4-1-5-1.6-11.2-3.2-16.7-4.2-8.7-1.5-14.2-2.5-23.3-1.7-2.6.3.3 1-6.6 1h-17.6Z"
    />
    <path
      fill="#BDC4CE"
      d="M311 69s-9.6 0-15.1 1.2c-8.3 1.8-5.4 2-2.9 2.8 2.4.7 8.5 2 10.7 2.5 2 .3 2 .4 7.2.7 4 .2 7 0 9.8 0 10.5 0 8-1.4 17-2.7 8.8-1.2 3.2-2.4 7.4-2.8 4.2-.4 13 2.7 13.3 2 .3-.8 10.3 2.5 10.5 1.1.2-1.1 7.9.7 1.3-1.3-5-1.6-6.3-1.8-11.8-2.8-8.7-1.5-14.2-2.5-23.2-1.7-2.7.3.2 1-6.7 1H311Z"
    />
    <path
      fill="#969CA5"
      d="M355.4 76.1s-9.6 0-15 1.2C332 79 323 84 324.6 84.8c2 1 3.4 1.6 4.6 2.7 2.5 2.5 8.8 2.2 13.9 3 7.8 1.2 11 .9 19 .9 12.3 0 22.7.4 31.5-.9 8.9-1.2 14.7-2.4 19-2.7 4.1-.4 12.3-.8 12.6-1.6.2-.8.4-.6.7-2 .2-1.1-3.1-2.2-9.7-4.2-5-1.5-8-2.3-13.4-3.2-8.7-1.5-14.2-2.6-23.3-1.7-2.6.3.3 1-6.6 1h-17.6Z"
    />
    <path
      fill="#6E727D"
      d="m330.2 86-.4 2-.6-.6-.7-.6.7-1.4 1-.5.6-1.1 2-1.6-.4.5-1 1-.3 1-.3.5-.6.8Z"
    />
    <path
      fill="#ACB4BE"
      d="M355.4 76.1s-9.6 0-15 1.2c-8.3 1.8-7.1 4.4-4.6 5.2 2.3.8 10.2 2 12.4 2.5 2 .3 5.5.1 10.7.4 4 .3 7.4.5 10.2.5 10.5 0 7.6-1.5 16.5-2.7 8.8-1.2 5.3-2.4 9.5-2.8 4.2-.4 7 .5 10.2.5 3.3 0 10 2.5 10.3 1.1.3-1.1 10.5.9 4-1.1-5-1.6-11.2-3.2-16.7-4.1-8.7-1.5-14.2-2.6-23.3-1.7-2.6.3.3 1-6.6 1h-17.6Z"
    />
    <path
      fill="#BDC4CE"
      d="M355.4 76.1s-9.5 0-15 1.2c-8.3 1.8-5.3 2-2.9 2.7 2.4.8 8.5 2.1 10.7 2.5 2 .4 2 .5 7.2.8 4 .2 7 0 9.8 0 10.5 0 8-1.5 17-2.7 8.8-1.2 3.2-2.5 7.4-2.9 4.2-.3 13.1 2.8 13.4 2 .2-.8 10.2 2.6 10.4 1.2.3-1.1 7.9.6 1.3-1.4-5-1.5-6.3-1.8-11.7-2.7-8.8-1.5-14.3-2.6-23.3-1.7-2.7.3.2 1-6.7 1h-17.6Z"
    />
    <path
      fill="#EBD4A8"
      d="M93 171.8a11 11 0 0 1 3.6-.8c1.8 0 4.3-.3 6-.8 8-2.4 17.1-6.3 21-8 1.4-.7 2.8-1 4.3-1h7c1.3-.1 5.4-.4 8 0 5.5.8 5.2 4 10.3 5.1 1.5.4 3.6.6 5.2.7 1.6.2 3.1.6 4.5 1.4l11.3 6.6 2.2 1.4c3 1.9 3.8 6.2.7 8-3.2 2-6 2.7-10.5 3.8-13.2 3.2-22.7-2-37.3-1.4-10.6.6-16 3.5-26.8 3.2-8.4-.3-19.2-3.1-24.7-4.7a3.7 3.7 0 0 1-2.4-4.9c.3-1 1.1-1.8 2-2.2l15.5-6.4Z"
    />
    <path
      fill="#969CA5"
      d="M81.7 164.6a13 13 0 0 1 3.9-.9 27 27 0 0 0 5.8-.8c8.1-2.7 17.2-6.8 21.2-8.7 1.4-.6 2.9-1 4.4-1h7c1.4-.1 5.5-.4 8.1 0 5.4.9 5.2 4.3 10.3 5.5 1.5.4 3.5.6 5.1.8 1.7.1 3.3.6 4.7 1.5l11.3 7 2.2 1.4c3 2.1 4 6.7.8 8.7-3.3 2-6 2.8-10.6 4-13.3 3.4-22.9-2.3-37.5-1.5-10.8.6-16.2 3.7-27 3.4-8.4-.3-19.1-3.3-24.8-5a4 4 0 0 1-2.5-5.2c.4-1.1 1.2-2 2.2-2.5l15.4-6.7Z"
    />
    <path
      fill="#ACB4BE"
      d="M81.7 164.6a13 13 0 0 1 4-.9 27 27 0 0 0 5.7-.8c8.1-2.7 17.2-6.8 21.2-8.7 1.4-.6 2.9-1 4.4-1h7c1.4-.1 5.5-.4 8.1 0 5.4.9 5.2 4.3 10.3 5.5 1.5.4 3.5.6 5.1.8 1.7.1 3.3.6 4.7 1.5l11.3 7-.8-.6c1.2.7.8 2.5-.5 2.7l-6.3 1.3c-13.3 3.4-22.9-2.3-37.5-1.5-10.8.6-16.2 3.7-27 3.4l-11.6-.2c-3.9 0-5-5.5-1.4-7l3.3-1.5Z"
    />
    <path
      fill="#BDC4CE"
      d="M81.7 164.6a13 13 0 0 1 4-.9 27 27 0 0 0 5.7-.8c8.1-2.7 17.2-6.8 21.2-8.7 1.4-.6 2.9-1 4.4-1h7c1.4-.1 5.5-.4 8.1 0 5.4.9 5.2 4.3 10.3 5.5 1.5.4 3.6.6 5.2.8a9 9 0 0 1 4.4 1.5l1.2.7.8.5.9.5c.8.6 2.7 1.8 1 2.3-13.3 3.4-22.9-2.3-37.5-1.5-10.8.6-16.2 5.9-27 5.5l-11.8-.2c-1.2 0-2-1.3-1.4-2.3.1-.3.4-.5.6-.6l2.9-1.3Z"
    />
    <path
      fill="#6E727D"
      d="m138 178.4-4.2 3.3 3.5.6 3 .4 3.8-4.8-5.1-3.9-1.2-2.3-1-1.4-2.5-4 1.5 4 .5 2.5v2.3l1.7 3.3Zm-15.5-2.1-1 4.2s2.3 0 3.8.2l3.1.2-1-6.7-8.1-2-3.1-1.6-2.2-1-5.7-2.7 4.9 3 2.7 2 2.1 2 4.5 2.4Zm-32.9 5.6v1.8s1 0 1.5-.2l1.5-.2-1.2-2.4-1.8-.8-1-2-.5-1.7-.4 1.7.4 1.6.6.9 1 1.3Zm65.1-6.4.5 6.8 2.2-.6 2-.5-2.9-7.2-1.8-1.1-.7-2.3-1.2-.5-1.3-1.3 1.5 2.4.2 1 .6 1.3 1 2Z"
    />
    <path fill="#E75252" d="m197.3 51 41.3-27.2L280 51.1V111h-82.6V51Z" />
    <path
      stroke="#FF5656"
      d="m278.4 50.8.3 60.2m-4.8-63.5V111m-4.5-66.3V111m-4.5-69.2V111m-4.5-69.2V111M256 38.9V111m-4.6-77.9V111M247 29.6V111m-4.5-84.3V111M238 26v85m-4.5-84.3V111M229 26.7V111m-4.5-81.4V111M220 29.6V111m-4.5-78.5V111M211 33.4V111m-4.4-75v75m-5.1-71.8V111m-4.4-71.8V111"
    />
    <path stroke="#fff" strokeWidth="1.6" d="M223.4 57.1h29.2v29.5h-29.2z" />
    <path fill="#fff" d="M224.2 59.3v-3.2h27.7v3.2z" />
    <path
      fill="#354661"
      stroke="#fff"
      strokeWidth=".8"
      d="M224.6 59.8h12.7v12.7h-12.7zm13.4 0h13.5v12.7H238zm-13.4 13.4h12.7v12.7h-12.7zm13.4 0h13.5v12.7H238z"
    />
    <path fill="#F76E6E" d="m159.8 44.7 37.5 6.4V111l-37.5-6.4v-60Z" />
    <path
      fill="#FF5656"
      d="M161 44.7h.7v60l-.6-.1v-60Zm2 .3h.6v60h-.6V45Zm1.9.3h.6v60h-.6v-60Zm1.6.3h.6v60h-.6v-60Zm1.9.4h.7v60l-.7-.1v-60Zm1.9.3h.7v60l-.7-.1v-60Zm2 .3h.6v60h-.6v-60Zm1.9.3h.6v60h-.6v-60Zm1.9.3h.7v60h-.7v-60Zm1.9.3h.7v60h-.7v-60Zm2 .4h.6v60l-.6-.1v-60Zm1.9.3h.6v60h-.6v-60Zm1.9.3h.6v60h-.6v-60Zm1.9.3h.7v60h-.7v-60Zm2 .3h.6v60.1l-.6-.1V49Zm1.9.4h.6v60l-.6-.1v-60Zm1.9.3h.6v60h-.6v-60Zm1.9.3h.7v60h-.7V50Zm1.9.3h.7v60h-.7v-60Z"
    />
    <path
      fill="#354661"
      stroke="#fff"
      strokeWidth="1.9"
      d="M166.5 82.2V61.5l22.8 3.7v21l-22.8-4Z"
    />
    <path fill="#FF9568" d="M156.4 46.7 199.2 17l39.3 5.5-45 31.5-37-7.3Z" />
    <path fill="#fff" d="M196.9 50.4h2.2V111h-2.2z" />
    <path fill="#EBE9EB" d="M198.2 50.4h1V111h-1z" />
    <path fill="#fff" d="M176.4 63.6h1.6v20.2h-1.6z" />
    <path stroke="#fff" strokeWidth="3.8" d="m281 51.7-42.4-27.9-45.5 29.8" />
    <path stroke="#EBE9EB" strokeWidth="2.6" d="m280.7 52.4-42-28-45 30.2" />
    <path fill="#fff" d="m154 46.9 43.8-30.1 1.7.3L157 46.9h-3Z" />
    <path
      fill="#354661"
      fillOpacity=".5"
      d="M196.6 112.4c-1-.4-.7-1.9.4-1.9h77.3a1 1 0 0 0 1-.6l4.4-10.3a1 1 0 0 1 1-.6h25.5c.2 0 .4 0 .6.2l23.3 17.4a1 1 0 0 1-.4 1.8l-21.1 3.6h-88.9a1 1 0 0 1-.4 0l-22.7-9.6Z"
    />
    <path
      fill="#969CA5"
      d="M249.8 105.6c.7-.3 1.5-.4 2.2-.5 1 0 2.4-.2 3.4-.5 4.6-1.5 9.8-3.8 12-4.9a6 6 0 0 1 2.6-.6h4c.8 0 3-.2 4.6 0 3 .5 3 2.5 5.9 3.2l2.9.4c1 0 1.8.4 2.7.8l6.4 4 1.2.9c1.8 1.2 2.3 3.8.5 5a18.5 18.5 0 0 1-6 2.2c-7.6 2-13-1.3-21.4-.8-6.2.3-9.3 2-15.4 1.9a61 61 0 0 1-14.2-2.9 2.3 2.3 0 0 1-1.4-3c.2-.6.6-1 1.2-1.3l8.8-3.9Z"
    />
    <path
      fill="#ACB4BE"
      d="M249.8 105.6c.7-.3 1.5-.4 2.3-.5 1 0 2.4-.2 3.3-.5 4.6-1.5 9.8-3.8 12-4.9a6 6 0 0 1 2.6-.6h4c.8 0 3-.2 4.6 0 3 .5 3 2.5 5.9 3.2l2.9.4c1 0 1.8.4 2.7.8l6.4 4-.4-.3c.6.4.4 1.5-.3 1.6l-3.6.7c-7.6 2-13-1.3-21.4-.8-6.2.3-9.3 2-15.4 1.9l-6.7-.1c-2.2 0-2.8-3.2-.8-4l1.9-.9Z"
    />
    <path
      fill="#BDC4CE"
      d="M249.8 105.6c.7-.3 1.5-.4 2.3-.5 1 0 2.4-.2 3.3-.5 4.6-1.5 9.8-3.8 12-4.9a6 6 0 0 1 2.6-.6h4c.8 0 3-.2 4.6 0 3 .5 3 2.5 5.9 3.2l3 .4c.8 0 1.7.4 2.4.9l.7.4.5.3c.2 0 .3.2.5.3.5.3 1.6 1 .6 1.2-7.6 2-13-1.2-21.4-.8-6.2.3-9.3 3.3-15.4 3.1a125 125 0 0 0-6.8 0c-.6 0-1.1-.8-.8-1.4.1-.1.2-.3.4-.3l1.6-.8Z"
    />
    <path
      fill="#6E727D"
      d="m282 113.5-2.4 1.9a101.2 101.2 0 0 0 3.6.6l2.3-2.8-3-2.2-.7-1.3-.6-.8-1.3-2.3.8 2.3.3 1.4v1.3l1 1.9Zm-8.9-1.2-.5 2.4a29 29 0 0 0 3.9.2l-.6-3.8-4.6-1.1-1.8-1-1.3-.5-3.2-1.6 2.8 1.8 1.6 1.1 1.2 1.2 2.5 1.3Zm-18.8 3.2v1h1l.8-.2-.7-1.4-1-.4-.6-1.1-.4-1-.1 1 .1.8.4.5.5.8Zm37.2-3.7.3 4 1.2-.4 1.1-.3-1.6-4.1-1-.7-.4-1.2-.7-.4-.7-.7.8 1.4.1.6.4.7.5 1.1Z"
    />
    <path
      fill="#969CA5"
      d="M183 108.6s-4.7 0-7.4.6c-4 .9-8.3 3.3-7.5 3.6 1 .5 1.7.8 2.2 1.3 1.2 1.2 4.3 1.1 6.7 1.5 3.8.5 5.3.4 9.2.4 6 0 11 .2 15.2-.4 4.3-.6 7.1-1.2 9.2-1.3 2-.2 6-.4 6-.8.2-.4.3-.3.4-1 .1-.5-1.5-1-4.7-2a60 60 0 0 0-17.7-2.3c-1.3 0 .1.4-3.2.4H183Z"
    />
    <path
      fill="#6E727D"
      d="M205.6 114v1l1.7-.3v-.8l-2.6-1-.3-.7-1.4-.4-1.8-.5.4.5 2.4.7v.7l1.6.8Zm-6.3.8v1h.8l1-.2-.8-1.4-1-.6-.6-1.2-.4-1.1-.2 1 .2 1 .4.6.6.9Zm3.2.1v.5h.9l-.4-.8-.5-.2-.2-.6-.2-.5v1l.2.2.2.4Zm-16.2.6v.5h-.9l.3-.8.6-.2.2-.5.2-.5v.9l-.2.3-.3.3Zm-15.5-2.1-.3 1-.2-.3-.4-.3.4-.7.5-.2.2-.6 1-.7-.2.2-.5.5-.1.5-.2.2-.2.4Zm42.2-.3.2 1h.5l.5-.1-.7-1.2-.5-.2-.2-.5h-.3l-.4-.3.5.4v.3l.2.2.2.4Z"
    />
    <path
      fill="#ACB4BE"
      d="M183 108.6s-4.7 0-7.4.6c-4 .9-3.4 2.2-2.2 2.5 1.2.4 5 1 6 1.2 1 .2 2.7 0 5.2.2l5 .3c5 0 3.6-.8 7.9-1.4 4.3-.5 2.6-1.1 4.6-1.3 2-.2 3.4.2 5 .2 1.5 0 4.8 1.3 5 .6 0-.6 5 .4 1.8-.6a69 69 0 0 0-8-2c-4.3-.7-7-1.2-11.3-.7-1.3 0 .1.4-3.2.4H183Z"
    />
    <path
      fill="#BDC4CE"
      d="M183 108.6s-4.7 0-7.3.6c-4 .9-2.6 1-1.4 1.3 1.1.4 4.1 1 5.1 1.2l3.5.4h4.8c5 0 3.9-.7 8.1-1.3 4.3-.6 1.6-1.2 3.7-1.4 2-.2 6.3 1.4 6.4 1 .1-.4 5 1.2 5 .5.2-.5 3.8.4.7-.6a25 25 0 0 0-5.7-1.3c-4.2-.8-6.9-1.3-11.3-.8-1.2 0 .2.4-3.2.4H183Z"
    />
  </svg>,
);
